import React from 'react';


export function SouthAfrica(props) {
	return (
		<svg width="513" height="343" viewBox="0 0 513 343" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_301_20)">
				<path d="M0 0.958496H513V342.951H0V0.958496Z" fill="white" />
				<path d="M114.247 171.956L0 57.6582V286.274L114.247 171.956Z" fill="black" />
				<path d="M161.507 171.955L0 10.3398V57.6581L114.247 171.956L0 286.274V333.504L161.507 171.955Z" fill="#FFB915" />
				<path d="M510.829 205.411C510.887 204.97 511.634 204.531 513 204.09V138.499H223.037L85.4967 0.958496H0V10.3398L161.507 171.955L0 333.504V342.951H85.4967L223.037 205.411H510.829Z" fill="#007847" />
				<path d="M504.163 238.868H236.894L132.811 342.951H513V238.868H504.163Z" fill="#000C8A" />
				<path d="M504.163 105.041H513V0.958496H132.811L236.894 105.041H504.163Z" fill="#E1392D" />
			</g>
			<defs>
				<clipPath id="clip0_301_20">
					<rect width="513" height="342" fill="white" transform="translate(0 0.95459)" />
				</clipPath>
			</defs>
		</svg>

	);
}